import React, { FunctionComponent, ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Loader from './Loader';

interface PrivateRouteProps {
  component: FunctionComponent;
  path: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component, ...args }) => {
  const loaderElement = (): JSX.Element => <Loader />;

  return (
    <Route
      component={withAuthenticationRequired(component, {
        onRedirecting: loaderElement,
      })}
      {...args}
    />
  );
};

export default PrivateRoute;
